<template>
  <div class="items-intro">
    <div class="max">
      <h2>檢測項目介紹</h2>
      <div class="tabs">
        <div
          v-for="tab in tabs"
          :key="tab.value"
          class="tab"
          :class="tab.active ? 'active': ''"
          @click="toggleTab(tab.value)"
        >
          <h3>{{ tab.label }}</h3>
        </div>
      </div>
      <div class="card-block">
        <div class="card" v-for="(item,index) in displayPlanList" :key="index">
          <div class="card-header">
            <h2>{{item.name}}</h2>
          </div>
          <q-separator class="w-full" />
          <div class="card-body">
            <div
              class="project-list"
            >
              <div v-if="item.projectA" class="project-a">
                <div v-for="(projectA, index) in item.projectA" :key="index" class="item">
                  <span class="tag">A方案</span>
                  <p>
                    {{ projectA }}
                  </p>
                </div>
              </div>
              <div v-if="item.projectB" class="project-b">
                <div v-for="(projectB, index) in item.projectB" :key="index" class="item">
                  <span class="tag">B方案</span>
                  <p>
                    {{ projectB }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <router-link to="/book-now/form" class="contact">
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_60_910" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="21">
          <rect y="0.222656" width="20" height="20" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_60_910)">
          <path d="M10.0001 6.88965C9.08341 6.88965 8.29869 7.21604 7.64591 7.86882C6.99314 8.52159 6.66675 9.30632 6.66675 10.223C6.66675 10.848 6.823 11.4244 7.1355 11.9521C7.448 12.4799 7.88203 12.8896 8.43758 13.1813C8.6598 13.2924 8.81605 13.4556 8.90633 13.6709C8.99661 13.8862 8.99314 14.1049 8.89591 14.3271C8.79869 14.5216 8.65286 14.6674 8.45842 14.7646C8.26397 14.8619 8.06953 14.8619 7.87508 14.7646C7.00008 14.348 6.30216 13.7299 5.78133 12.9105C5.2605 12.091 5.00008 11.1952 5.00008 10.223C5.00008 8.83409 5.48619 7.65354 6.45841 6.68132C7.43064 5.70909 8.61119 5.22298 10.0001 5.22298C10.9862 5.22298 11.8924 5.4834 12.7188 6.00423C13.5452 6.52507 14.1598 7.23687 14.5626 8.13965C14.6459 8.33409 14.6424 8.52854 14.5522 8.72298C14.4619 8.91743 14.3195 9.05632 14.1251 9.13965C13.9029 9.23687 13.6806 9.23687 13.4584 9.13965C13.2362 9.04243 13.0695 8.8827 12.9584 8.66048C12.6667 8.10493 12.257 7.6709 11.7292 7.3584C11.2015 7.0459 10.6251 6.88965 10.0001 6.88965ZM10.0001 3.55632C8.13897 3.55632 6.56258 4.20215 5.27091 5.49382C3.97925 6.78548 3.33341 8.36187 3.33341 10.223C3.33341 11.973 3.9098 13.473 5.06258 14.723C6.21536 15.973 7.6598 16.6813 9.39592 16.848C9.63203 16.8758 9.83689 16.9799 10.0105 17.1605C10.1841 17.341 10.264 17.5494 10.2501 17.7855C10.2362 18.0216 10.1494 18.216 9.98967 18.3688C9.82994 18.5216 9.63203 18.591 9.39592 18.5771C8.31258 18.5077 7.30217 18.2369 6.36467 17.7647C5.42716 17.2924 4.60772 16.6778 3.90633 15.9209C3.20494 15.164 2.65633 14.2959 2.2605 13.3167C1.86466 12.3376 1.66675 11.3063 1.66675 10.223C1.66675 9.0702 1.8855 7.98687 2.323 6.97298C2.7605 5.95909 3.35425 5.07715 4.10425 4.32715C4.85425 3.57715 5.73619 2.9834 6.75008 2.5459C7.76397 2.1084 8.8473 1.88965 10.0001 1.88965C12.1806 1.88965 14.0799 2.6327 15.698 4.11882C17.3161 5.60493 18.2015 7.43826 18.3542 9.61882C18.382 9.84104 18.3161 10.032 18.1563 10.1917C17.9966 10.3515 17.7987 10.4383 17.5626 10.4521C17.3265 10.466 17.1147 10.3896 16.9272 10.223C16.7397 10.0563 16.632 9.85493 16.6042 9.61882C16.3959 7.95215 15.6702 6.52507 14.4272 5.33757C13.1841 4.15007 11.7084 3.55632 10.0001 3.55632ZM16.2917 18.1396L13.5417 15.4105L12.9167 17.3063C12.8473 17.5008 12.7154 17.5945 12.5209 17.5876C12.3265 17.5806 12.1945 17.4799 12.1251 17.2855L10.2292 10.973C10.1737 10.8202 10.2084 10.6813 10.3334 10.5563C10.4584 10.4313 10.5973 10.3966 10.7501 10.4521L17.0626 12.348C17.257 12.4174 17.3577 12.5494 17.3647 12.7438C17.3716 12.9383 17.2779 13.0702 17.0834 13.1396L15.1876 13.7646L17.9376 16.5147C18.1737 16.7508 18.2917 17.0216 18.2917 17.3271C18.2917 17.6327 18.1737 17.9035 17.9376 18.1396C17.7015 18.3758 17.4272 18.4938 17.1147 18.4938C16.8022 18.4938 16.5279 18.3758 16.2917 18.1396Z" fill="#BA8F69"/>
          </g>
        </svg>
        <div>聯絡我們</div>
      </router-link>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.w-full{
  width: 100%;
}
.active{
  background-color: #BA8F69 !important;
  h3{
    color: white !important;
  }
}
.items-intro{
  @include basic-flex(column);
  padding: 50px 5% 80px 5% !important;
  background-color: #D7C6B1;
  .max{
    width: 100%;
    max-width: 1350px;
    @include basic-flex(column);
    h2{
      font-size: 24px;
      line-height: 24px;
      font-weight: 700;
    }
    .tabs{
      width: 100%;
      display: flex;
      background-color: #fff;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: rgba(0, 0, 0, .1);
      margin-top: 12px;
      .tab{
        flex: 1;
        display: flex;
        justify-content: center;
        transition-duration: .5s;
        cursor: pointer;
        h3 {
          font-size: 16px;
          font-weight: 600;
          line-height: 28px;
          color: #3b7085;
        }
      }
    }
    .card-block{
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      width: 100%;
      @include m-spacing(20px, 5%);
      // flex-direction: row;
      .card{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: calc(25% - 9px);
        border-radius: 10px;
        overflow: hidden;
        background-color: white;
        padding: 12px 16px;
        gap: 10px;
        .card-header{
          display: flex;
          justify-content: center;
          width: 100%;
          h2{
            font-size: 16px;
            margin: 0;
            font-weight: 700;
            line-height: 32px;
          }
        }
        .card-body{
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
          width: 100%;
          .project-list{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: .4rem;
            font-size: 18px;
            font-weight: 500;
            width: 100%;
            p {
              padding: 0;
              margin: 0;
            }
            .project-a {
              width: 100%;
              display: flex;
              flex-direction: column;
              gap: 8px;
              .item {
                display: flex;
                align-items: center;
                gap: 8px;
                .tag {
                  border: solid 1px #ba8f69;
                  font-size: 12px;
                  line-height: 12px;
                  padding: 4px 10px;
                  border-radius: 4px;
                  color: #ba8f69;
                  white-space: nowrap;
                }
                p{
                  font-size: 14px;
                }
              }
            }
            .project-b {
              width: 100%;
              display: flex;
              flex-direction: column;
              gap: 8px;
              .item {
                display: flex;
                align-items: center;
                gap: 8px;
                .tag {
                  border: solid 1px #3b7085;
                  font-size: 12px;
                  line-height: 12px;
                  padding: 4px 10px;
                  border-radius: 4px;
                  color: #3b7085;
                  white-space: nowrap;
                }
                p{
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }
    .contact{
      background-color: #fff;
      border: solid 2px #ba8f69;
      color: #ba8f69;
      display: flex;
      padding: 10px 30px;
      gap: 10px;
      font-size: 16px;
      border-radius: 12px;
      margin-top: 50px;
      text-decoration: none;
      svg{
        margin-top: 3px;
      }
    }
  }
}

@media (max-width: 1130px) {
  .items-intro{
    .max{
      .card-block{
        .card{
          width: calc(50% - 6px);
        }
      }
    }
  }
}

@media (max-width: 580px) {
  .items-intro{
    .max{
      .tabs{
        width: 100%;
        display: flex;
        background-color: #fff;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: rgba(0, 0, 0, .1);
        margin-top: 12px;
        .tab{
          h3{
            font-size: 12px;
            line-height: 16px;
          }
        }
      }
      .card-block{
        .card{
          width: 100%;
          .card-header{
            h2{
              font-size: 18px;
              font-weight: 700;
            }
          }
          .card-body{
            .project-list{
              div{
                img{
                  width: 20px
                }
              }
            }
          }
        }
      }
      h2{
        font-size: 20px;
        line-height: 20px;
        font-weight: 600;
        letter-spacing: 1px;
        margin: 0 0 15px 0;
      }
    }
  }
}
</style>
<script>
export default {
  data () {
    return {
      tabs: [
        {
          label: 'PROJECT A+B',
          value: 'a+b',
          active: true
        },
        {
          label: 'PROJECT A.',
          value: 'a',
          active: false
        },
        {
          label: 'PROJECT B.',
          value: 'b',
          active: false
        }
      ],
      plan: [
        {
          name: '文件相關檢查',
          projectA: [
            '核對契約內容(建材、平面圖)',
            '建築法規核對'
          ],
          projectB: [
            '室內尺寸丈量'
          ]
        },
        {
          name: '機電相關檢測',
          projectA: [
            '電力相關檢測 (接線、插座、配電盤等)',
            '弱電相關檢測 (電視、網路、電話盤等)'
          ]
        },
        {
          name: '室內環境檢查',
          projectB: [
            '輻射檢測',
            '室內噪音檢測',
            'HCHO(甲醛)檢測'
          ]
        },
        {
          name: '裝修工程檢測',
          projectA: [
            '地坪收邊檢視',
            '地、壁磚檢測',
            '櫥櫃五金功能檢測',
            '室內櫃體、門片垂直水平檢測',
            '其他室內裝修施工品質檢查'
          ],
          projectB: [
            '壁紙完整度檢視',
            '石材表面完整度檢查',
            '窗簾、裱布表面完整度檢查'
          ]
        },
        {
          name: '結構安全檢視',
          projectA: [
            '主要結構裂縫目視判定 (實際耐震評估需另請專業團體檢測)'
          ]
        },
        {
          name: '設備、排水測試',
          projectA: [
            '水壓測試',
            '管道間檢查',
            '浴室設備功能檢查',
            '浴室地坪洩水檢測',
            '淋浴間防水測試',
            '排風設備管路檢查'
          ]
        },
        {
          name: '屋況檢查',
          projectA: [
            '屋內排水檢測',
            '磁磚檢查',
            '紅外線熱像儀滲漏水檢測',
            '水分計含水率檢測',
            '排水孔內視鏡檢測',
            '窗戶滲水檢測',
            '門、窗、牆面、地板垂直水平檢測'
          ],
          projectB: [
            '天花板、壁面油漆施工品質檢查'
          ]
        },
        {
          name: '售後服務',
          projectA: [
            '驗屋報告(電子檔)',
            '複驗專業諮詢'
          ]
        }
      ]
    }
  },
  computed: {
    displayPlanList: function () {
      const tab = this.tabs.find(item => item.active)
      if (tab.value === 'a+b') {
        return this.plan
      } else if (tab.value === 'a') {
        return this.plan.filter(item => item.projectA).map(item => {
          return {
            name: item.name,
            projectA: item.projectA
          }
        })
      } else if (tab.value === 'b') {
        return this.plan.filter(item => item.projectB).map(item => {
          return {
            name: item.name,
            projectB: item.projectB
          }
        })
      } else {
        return []
      }
    }
  },
  methods: {
    toggleTab: function (value) {
      this.tabs.forEach(item => {
        if (item.value === value) {
          item.active = true
        } else {
          item.active = false
        }
      })
    }
  }
}
</script>
